import React, {useEffect, useState, useRef} from 'react';

import {
    empty,
    logIt
} from "__globals/global-functions";

import {
    getJsonContent,
    setContent,
    getJsonResultCopy
} from "__globals/copy-functions";

import {RedeemPrizeForm} from "../WinningResults/RedeemPrizeForm/RedeemPrizeForm";

import { WinningAnimationWrapper } from '_pages/Variations/Animation/WinningAnimation/WinningAnimationWrapper';

import * as GC from "__globals/GLOBAL-CONSTANTS";
import {addCSSClass} from "../../../../__globals/css-functions";

export const WinRedeemForm = props => {

    logIt( "WIN REDEEM FORM PAGE IS CALLED", null, false );

    // LOCAL VARIABLES
    const [showTitle, setShowTitle] = useState( false);
    const [showResultCopy, setShowResultCopy] = useState( true);
    const [showCopy, setShowCopy] = useState( false);
    const [showActionOne, setShowActionOne] = useState( true);
    const [showActionTwo, setShowActionTwo] = useState( false);
    const [showActionThree, setShowActionThree] = useState( false);
    const [showShowResultsButton, setShowShowResultsButton] = useState( true);

    const handleActionButton1 = () => {
        let action = props.gameClaim?.parameters?.resultScreen?.actionOne?.action;
        let value = props.gameClaim?.parameters?.resultScreen?.actionOne?.value;
        props.handleAction( action, value );
    }

    const handleActionButton2 = () => {
        let action = props.gameClaim?.parameters?.resultScreen?.actionTwo?.action;
        let value = props.gameClaim?.parameters?.resultScreen?.actionTwo?.value;
        props.handleAction( action, value );
    }

    const handleActionButton3 = () => {
        let action = props.gameClaim?.parameters?.resultScreen?.actionThree?.action;
        let value = props.gameClaim?.parameters?.resultScreen?.actionThree?.value;
        props.handleAction( action, value );
    }

    //const action1Ref = useRef( <div id="ai_win_screen_button_1" onClick={handleActionButton1}>Action One</div> );

    /** Sets the result css from the game claim */
    useEffect(() => {
        if ( !empty(props.gameClaim) && !empty(props.promotion) ) {
            setShowTitle( props.gameClaim?.parameters?.resultScreen?.showTitle );
            setShowResultCopy( props.gameClaim?.parameters?.resultScreen?.showResultCopy );
            setShowCopy( props.gameClaim?.parameters?.resultScreen?.showCopy );
            setShowActionOne( props.gameClaim?.parameters?.resultScreen?.actionOne?.show );
            setShowActionTwo( props.gameClaim?.parameters?.resultScreen?.actionTwo?.show );
            setShowActionThree( props.gameClaim?.parameters?.resultScreen?.actionThree?.show );
            setShowShowResultsButton( props.gameClaim?.parameters?.resultScreen?.showResultsButton?.show );
        }
    }, [props.gameClaim, props.promotion]);

    {/** Put in copy based on show flags */}
    useEffect(() => {
        if ( showTitle && !empty(props.promotion) ) {
            let redeemFormWinScreenTitle = getJsonContent(props.promotion, GC.RESULT_FORM, "title", "<h2>DEFAULT TITLE</h2>", props.entry );
            setContent("form_win_screen_title", redeemFormWinScreenTitle);
        }
    }, [showTitle]);
    useEffect(() => {
        if ( showResultCopy && !empty(props.promotion) && !empty(props.gameClaim) ) {
            let resultCopy = getJsonResultCopy(props.promotion, GC.RESULT_FORM, props.gameClaim, "<h2>ERROR</h2>", props.entry );
            setContent("form_win_screen_result_copy", resultCopy);
        }
    }, [showResultCopy]);
    useEffect(() => {
        if ( showCopy && !empty(props.promotion) ) {
            let redeemFormWinScreenCopy = getJsonContent(props.promotion, GC.RESULT_FORM, "copy", "<h2>DEFAULT COPY</h2>", props.entry );
            setContent("form_win_screen_copy", redeemFormWinScreenCopy);
        }
    }, [showCopy]);
    useEffect(() => {
        if ( showActionOne && !empty(props.promotion) ) {
            let redeemFormWinScreenButton1 = getJsonContent(props.promotion, GC.RESULT_FORM, "button1", "<h2>DEFAULT BTN 1</h2>", props.entry );
            setContent("form_win_screen_button_1", redeemFormWinScreenButton1);
//action1Ref.current.click.handler = handleActionButton1;
        }
    }, [showActionOne]);
    useEffect(() => {
        if ( showActionTwo && !empty(props.promotion) ) {
            let redeemFormWinScreenButton2 = getJsonContent(props.promotion, GC.RESULT_FORM, "button2", "<h2>DEFAULT BTN 2</h2>", props.entry );
            setContent("form_win_screen_button_2", redeemFormWinScreenButton2);
        }
    }, [showActionTwo]);
    useEffect(() => {
        if ( showActionThree && !empty(props.promotion) ) {
            let redeemFormWinScreenButton3 = getJsonContent(props.promotion, GC.RESULT_FORM, "button3", "<h2>DEFAULT BTN 3</h2>", props.entry );
            setContent("form_win_screen_button_3", redeemFormWinScreenButton3);
        }
    }, [showActionThree]);
    useEffect(() => {
        if ( showShowResultsButton && !empty(props.promotion) ) {
            let redeemFormWinScreenShowResultsButton = getJsonContent(props.promotion, GC.RESULT_FORM, "showResultsButton", "<h2>DEFAULT BTN 3</h2>", props.entry );
            setContent("form_win_screen_show_results_button", redeemFormWinScreenShowResultsButton);
        }
    }, [showShowResultsButton]);
    {/** END of put in copy based on show flags */}

    // RETURN THE GAME RESULT
    return (
        <div id='win_redeem_form' >

            {showTitle && <div id="form_win_screen_title">Title One</div>}
            {showCopy && <div id="form_win_screen_copy">Copy One</div>}
            {showResultCopy && <div id="form_win_screen_result_copy">Result Copy</div>}
            {showActionOne && <div id="form_win_screen_button_1" onClick={handleActionButton1}>Action One</div>}
            {showActionTwo && <div id="form_win_screen_button_2" onClick={handleActionButton2}>Action Two</div>}
            {showActionThree && <div id="form_win_screen_button_3" onClick={handleActionButton3}>Action Three</div>}
            {showShowResultsButton && <div id="form_win_screen_show_results_button" onClick={props.showForm} >Redeem Your Prize</div>}

            <RedeemPrizeForm
                promotion={props.promotion}
                entry={props.entry}
                variables={props.entry.variables}
                gameClaim={props.gameClaim}
            />

            <WinningAnimationWrapper
                promotion={props.promotion}
                animationGo={props.animationGo}
            />

        </div>
    );
}

export default WinRedeemForm;